import service from '@/utils/request'
import servicePush from '@/utils/requestPush'

// 统一接口获取
export const getApi = (url: any,data: any) => {
    return service.post(url, data)
}

// 统一接口获取
export const postApi = (url: any,data: any,msg: any = '') => {
    // if (url == '/api/client/sms/code') {
    //     console.log(data);
    //     return new Promise((resolve) => {
    //         resolve({
    //             code: 200,
    //             data: {
    //                 cn: "发送成功",
    //                 en: "发送成功",
    //             }
    //         })
    //     })
    // }
    const headers: any = {
        loading: msg
    }
    return service.post(url, data, headers)
}

// 推送服务器
export const postApiPush = (url: any,data: any,msg: any = '') => {
    const headers: any = {
        loading: msg
    }
    return servicePush.post(url, data, headers)
}

// 获取阿里云直传参数
export const getUploadToken = () => {
    return service.post('/api/direct_upload/upload_web_token')
}

// 获取阿里云直传参数
export const getDashboard = () => {
    return service.post('/api/main/home/dashboard')
}

// 获取用户列表
export const getAdminList = (data: any) => {
    return service.post('/admin/list', data)
}
// 获取用户详情
export const getAdminInfo = (data: any) => {
    return service.post('/admin/edit', data)
}
// 新增或者更新用户员工
export const setAdminInfo = (data: any) => {
    return service.post(data.id == undefined ? '/admin/create' : '/admin/update', data)
}
// 修改密码
export const ChangePassword = (data: any) => {
    return service.post('/admin/update_passwd', data)
}

// 获取部门列表
export const getDepartmentList = (data: any) => {
    return service.post('/admin/department/list', data)
}
// 获取部门权限信息
export const getDepartmentPermission = (data: any) => {
    return service.post('/admin/department_has_permission/get', data)
}

// 获取权限列表
export const getPermissionList = (data: any) => {
    let url = '/admin/permission/list'
    // if (localStorage.getItem('user_system') == '2') {
    //     url = '/api/client/permission/list'
    // }
    return service.post(url, data)
}
// 新增权限
export const addPermission = (data: any) => {
    let url = '/admin/permission/store'
    if (localStorage.getItem('user_system') == '2') {
        url = '/api/client/permission/store'
    }
    return service.post(url, data)
}
// 获取权限信息
export const editPermission = (data: any) => {
    let url = '/admin/permission/edit'
    if (localStorage.getItem('user_system') == '2') {
        url = '/api/client/permission/edit'
    }
    return service.post(url, data)
}
// 更新权限
export const updatePermission = (data: any) => {
    let url = '/admin/permission/update'
    if (localStorage.getItem('user_system') == '2') {
        url = '/api/client/permission/update'
    }
    return service.post(url, data)
}
// 更新用户权限
export const updateUserPermission = (data: any) => {
    let url = '/admin/permission/update_user_permission'
    if (localStorage.getItem('user_system') == '2') {
        url = '/api/client/permission/update_user_permission'
    }
    return service.post(url, data)
}

// 获取用户权限
export const getUserPermission = (data: any) => {
    let url = '/admin/permission/get_all_permission'
    return service.post(url, data)
}

// 获取仓库列表
export const getWarehouseList = (data: any) => {
    return service.post('/admin/warehouse/list', data)
}
// 获取客户列表
export const getCustomerList = (data: any) => {
    return service.post('/admin/customer/list', data)
}

// 新增或者更新入库单
export const set_receipts_lists = (data: any) => {
    return service.post(data.id == undefined ? '/admin/receiptsList/store' : '/admin/receiptsList/update', data)
}
// 删除入库单
export const del_receipts_lists = (data: any) => {
    return service.post('/admin/receiptsList/destory', data)
}
// 入库单详情
export const get_receipts_lists = (data: any) => {
    return service.post('/admin/receiptsList/edit', data)
}
// 新增或者更新入库单详情
export const set_receipts_options = (data: any) => {
    return service.post(data.id == undefined ? '/admin/receiptsOption/store' : '/admin/receiptsOption/update', data)
}
